import * as Api from '../../../api/Api';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import TableFromServer from "../../../Components/Table/TableFromServer";
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import { PageTitle } from '../../../../_metronic/layout/core';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import Modal from 'react-bootstrap/Modal';
import { useState, useContext, useEffect } from 'react';
import { useQuery } from 'react-query';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import { Loading } from "../../../Components/Loading/Loading";
import { ErrorConnection } from "../../../Components/Error/Error";
import { Spinner } from 'react-bootstrap';


export default function Inflacion({ title }) {

    const animatedComponents = makeAnimated();

    const lsDate = sessionStorage.getItem("inflacion_anio");
    let anioActual = lsDate == null ? (new Date()).getFullYear() : lsDate;
    let anioActualConst = (new Date()).getFullYear();

    const [anio, setAnio] = useState({ value: anioActual, label: anioActual });

    const [inflacion_enero, setInflacion_enero] = useState(0);
    const [inflacion_febrero, setInflacion_febrero] = useState(0);
    const [inflacion_marzo, setInflacion_marzo] = useState(0);
    const [inflacion_abril, setInflacion_abril] = useState(0);
    const [inflacion_mayo, setInflacion_mayo] = useState(0);
    const [inflacion_junio, setInflacion_junio] = useState(0);
    const [inflacion_julio, setInflacion_julio] = useState(0);
    const [inflacion_agosto, setInflacion_agosto] = useState(0);
    const [inflacion_setiembre, setInflacion_setiembre] = useState(0);
    const [inflacion_octubre, setInflacion_octubre] = useState(0);
    const [inflacion_noviembre, setInflacion_noviembre] = useState(0);
    const [inflacion_diciembre, setInflacion_diciembre] = useState(0);
    const [setDatos, setSetDatos] = useState(false);


    const [guardadoExitoso, setGuardadoExitoso] = useState(false);


    let anioList = [];
    for (let index = anioActualConst; index > 2015; index--) {
        anioList.push({ value: index, label: index });
    }

    const token = useGetToken();

    const validateNumber = (value) => {
        const rgx = /^[0-9]*\.?[0-9]*$/;
        return value.match(rgx);
    }

    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    let { data, isLoading, isError, error, isFetching } = useQuery(
        ["GetInflacionxAnios", {
            anio: anio.value
        }],
        async () => await Api.GetInflacion_Anio(
            { anio: anio.value, token: token }
        ),
        { enabled: true }
    );
    useEffect(() => {
        if (data) {
            if (data.data === null) {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
            else {
                setInflacion_enero(data.data.enero);
                setInflacion_febrero(data.data.febrero);
                setInflacion_marzo(data.data.marzo);
                setInflacion_abril(data.data.abril);
                setInflacion_mayo(data.data.mayo);
                setInflacion_junio(data.data.junio);
                setInflacion_julio(data.data.julio);
                setInflacion_agosto(data.data.agosto);
                setInflacion_setiembre(data.data.setiembre);
                setInflacion_octubre(data.data.octubre);
                setInflacion_noviembre(data.data.noviembre);
                setInflacion_diciembre(data.data.diciembre);
            }
        }
    }, [data]);

    let { data: dataSetInflacion, isLoading: isLoadingInflacion, isError: isErrorSetInflacion, error: errorSetInflacion, isFetching: isFetchingSetInflacion } = useQuery(
        ["SetInflacionxAnios", {
            anio: anio.value,
            enero: inflacion_enero,
            febrero: inflacion_febrero,
            marzo: inflacion_marzo,
            abril: inflacion_abril,
            mayo: inflacion_mayo,
            junio: inflacion_junio,
            julio: inflacion_julio,
            agosto: inflacion_agosto,
            setiembre: inflacion_setiembre,
            octubre: inflacion_octubre,
            noviembre: inflacion_noviembre,
            diciembre: inflacion_diciembre
        }],
        async () => await Api.SetInflacion_Anio(
            {
                anio: anio.value,
                enero: inflacion_enero,
                febrero: inflacion_febrero,
                marzo: inflacion_marzo,
                abril: inflacion_abril,
                mayo: inflacion_mayo,
                junio: inflacion_junio,
                julio: inflacion_julio,
                agosto: inflacion_agosto,
                setiembre: inflacion_setiembre,
                octubre: inflacion_octubre,
                noviembre: inflacion_noviembre,
                diciembre: inflacion_diciembre,
                token: token
            }
        ),
        { enabled: Boolean(setDatos) }
    );
    useEffect(() => {
        if (dataSetInflacion != undefined)
            if (dataSetInflacion) {
                setSetDatos(false);
                setGuardadoExitoso(true);
            }
            else {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: dataSetInflacion.errorId });
            }
    }, [dataSetInflacion]);


    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error} />)
    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.INFLACION]} >
                <PageTitle>{title}</PageTitle>

                <div className="card my-5">
                    <div className="card-header border-0 pt-6" style={{ zIndex: 10 }}>
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bolder fs-3 mb-1">Factor de Inflación</span>
                            <span className="text-muted fw-bold fs-7">Ingrese el valor solicitado</span>
                        </h3>

                        <div className="card-toolbar">
                            <div style={{ minWidth: "200px" }}>
                                <div className="fw-bold fs-7 text-gray-600 mb-1">Año:</div>
                                <Select
                                    classNamePrefix='filter'
                                    components={animatedComponents}
                                    defaultValue={anio}
                                    isMulti={false}
                                    closeMenuOnSelect={true}
                                    options={anioList}
                                    onChange={(anioX) => { sessionStorage.setItem("inflacion_anio", anioX.value); setAnio(anioX); }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-body ">

                        <div className="row mb-7">

                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className='fs-6 fw-bold form-label mb-2'>Enero</label>
                                    <input type="text" className='form-control form-control-solid' mes='enero' onChange={(e) => (validateNumber(e.target.value)) ? setInflacion_enero(e.target.value) : null} value={inflacion_enero} />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className='fs-6 fw-bold form-label mb-2'>Febrero</label>
                                    <input type="text" className='form-control form-control-solid' mes='febrero' onChange={(e) => (validateNumber(e.target.value)) ? setInflacion_febrero(e.target.value) : null} value={inflacion_febrero} />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className='fs-6 fw-bold form-label mb-2'>Marzo</label>
                                    <input type="text" className='form-control form-control-solid' mes='marzo' onChange={(e) => (validateNumber(e.target.value)) ? setInflacion_marzo(e.target.value) : null} value={inflacion_marzo} />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className='fs-6 fw-bold form-label mb-2'>Abril</label>
                                    <input type="text" className='form-control form-control-solid' mes='abril' onChange={(e) => (validateNumber(e.target.value)) ? setInflacion_abril(e.target.value) : null} value={inflacion_abril} />
                                </div>
                            </div>
                        </div>
                        <div className="row mb-7">
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className='fs-6 fw-bold form-label mb-2'>Mayo</label>
                                    <input type="text" className='form-control form-control-solid' mes='mayo' onChange={(e) => (validateNumber(e.target.value)) ? setInflacion_mayo(e.target.value) : null} value={inflacion_mayo} />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className='fs-6 fw-bold form-label mb-2'>Junio</label>
                                    <input type="text" className='form-control form-control-solid' mes='junio' onChange={(e) => (validateNumber(e.target.value)) ? setInflacion_junio(e.target.value) : null} value={inflacion_junio} />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className='fs-6 fw-bold form-label mb-2'>Julio</label>
                                    <input type="text" className='form-control form-control-solid' mes='julio' onChange={(e) => (validateNumber(e.target.value)) ? setInflacion_julio(e.target.value) : null} value={inflacion_julio} />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className='fs-6 fw-bold form-label mb-2'>Agosto</label>
                                    <input type="text" className='form-control form-control-solid' mes='agosto' onChange={(e) => (validateNumber(e.target.value)) ? setInflacion_agosto(e.target.value) : null} value={inflacion_agosto} />
                                </div>
                            </div>
                        </div>
                        <div className="row mb-7">
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className='fs-6 fw-bold form-label mb-2'>Septiembre</label>
                                    <input type="text" className='form-control form-control-solid' mes='noviembre' onChange={(e) => (validateNumber(e.target.value)) ? setInflacion_setiembre(e.target.value) : null} value={inflacion_setiembre} />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className='fs-6 fw-bold form-label mb-2'>Octubre</label>
                                    <input type="text" className='form-control form-control-solid' mes='noviembre' onChange={(e) => (validateNumber(e.target.value)) ? setInflacion_octubre(e.target.value) : null} value={inflacion_octubre} />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className='fs-6 fw-bold form-label mb-2'>Noviembre</label>
                                    <input type="text" className='form-control form-control-solid' mes='noviembre' onChange={(e) => (validateNumber(e.target.value)) ? setInflacion_noviembre(e.target.value) : null} value={inflacion_noviembre} />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className='fs-6 fw-bold form-label mb-2'>Diciembre</label>
                                    <input type="text" className='form-control form-control-solid' mes='diciembre' onChange={(e) => (validateNumber(e.target.value)) ? setInflacion_diciembre(e.target.value) : null} value={inflacion_diciembre} />
                                </div>
                            </div>
                        </div>

                        <button className="btn btn-dark" onClick={() => setSetDatos(true)}>Guardar</button>
                        {(setDatos) && <div className="spinner-border"></div>}

                    </div>
                </div>

                <Modal
                    size="sm"
                    show={guardadoExitoso}
                    onHide={() => setGuardadoExitoso(false)}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title id="example-modal-sizes-title-sm" style={{ margin: 'auto' }}>
                            Guardado Exitoso
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Footer style={{ margin: 'auto' }}>
                        <button type="button" className="btn btn-primary" onClick={() => { setGuardadoExitoso(false); window.location.reload(false); }}>
                            Aceptar
                        </button>
                    </Modal.Footer>
                </Modal>
            </PermissionsGate>
        </>
    )
}